import { USER_COOKIE_NAME } from '../constants';
import { getCookie } from './cookies';
import { adler32 } from './hashes';

/**
 * Returns user check hash data based on user cookie.
 * The cookie should always be set at least in Online session.
 * The 'unknown' value is just a fallback for testing.
 */
export const getUserCheck = () => adler32((getCookie(USER_COOKIE_NAME) ?? '').trim() || 'unknown');
